import React from "react"
import { useForm } from "react-hook-form";
import styles from './Slices.module.css'
import exampleImage from '../../assets/constructor/song_structure_example.jpg'
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addSliceAC, deleteSliceAC, saveSlicesFormDataAC } from "../../store/actions/builderActions";
import { CustomH2 } from "../common/customH2/CustomH2";
import { AppLink } from "../common/link/AppLink";
import { AppButton } from "../common/button/AppButton";

export const Slices = () => {
    const { register, unregister, handleSubmit, setValue, getValues, formState: { errors } } = useForm();
    const slices = useSelector(state => state.builder.slices)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const handleAddInput = () => {
        dispatch(addSliceAC())
    }

    const handleDeleteInput = (sliceNumber) => {
        unregister(sliceNumber)
        dispatch(deleteSliceAC(sliceNumber))
    }

    const onChange = async (e) => {
        let values = await getValues()
        if (e.target.id) {
            if (values[e.target.id].hasAlt) {
                setValue(`${e.target.id}.value`, values[e.target.id].value + '_Alt')
            } else {
                setValue(`${e.target.id}.value`, values[e.target.id].value.replace('_Alt', ''))
            }
        }
        dispatch(saveSlicesFormDataAC(values))
    }

    const onSubmit = () => {
        navigate('/builder/files')
    }

    return <div className={styles.constructorContainer}>
        <CustomH2>Define Your Song Structure</CustomH2>
        <img src={exampleImage} className={styles.exampleImage} alt='example song structure' />
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.slicesContainer}>
                {Object.keys(slices).map((key, index) => {
                    return <span className={styles.sliceContainer} key={key} onDoubleClick={Object.keys(slices).length - 1 === index && Object.keys(slices).length > 1 ? () => handleDeleteInput(key) : null}>
                        <input
                            className={styles.slice}
                            {...register(`${key}.value`, { onChange: onChange })}
                            defaultValue={slices[key].value}
                            placeholder="your slice..."
                            autoFocus
                            required />
                        <input
                            className={styles.checkbox}
                            id={key} {...register(`${key}.hasAlt`, { onChange: (e) => onChange(e) })}
                            type='checkbox'
                            defaultChecked={slices[key].hasAlt} />
                        {(Object.keys(slices).length - 1 === index && Object.keys(slices).length > 1) && <label className={styles.deleteTip}>double click to delete</label>}
                        {(Object.keys(slices).length - 1 === index && slices[key].value) && <label className={styles.toggleAlt} htmlFor={key}>{slices[key].hasAlt ? 'Delete Alt' : 'Add Alt'}</label>}
                    </span>
                })}
                <span className={styles.addButton} onClick={handleAddInput} >
                    add more...
                </span>
            </div>
            {/* <div> */}
                <AppLink to='/builder/art'>Go Back</AppLink>
                {/* <div className={styles.sendButtonContainer}>
                    <input id='submit' type="submit" />
                    <label htmlFor="submit" >Next</label>
                </div> */}
                <AppButton
                    // disabled={isDisabled}
                    type='submit'
                    value='next'
                />
            {/* </div> */}
        </form>
    </div>
}